<template>
    <div class="m-1">
        <small class="flex-grow-0 mr-2 text-secondary">{{ filter.title }}</small>
        <list-select v-if="!filter.local"
                     ref="list"
                     :name="filter.name"
                     :label="filter.title"
                     v-model="selected"
                     :url="filter.source"
                     :initial-filters="filter.initialFilters ? filter.initialFilters : []"
                     :label-key="labelKey()"
                     :has-search="hasSearch"
                     v-on:select-added="onFilterAdded"
                     v-on:select-removed="onFilterRemoved" />
    </div>
</template>

<script>
    import ListSelect from "@/components/Select/ListSelect";

    export default {
        name: "DataTableFilter",
        components: {
            ListSelect,
        },
        props: {
            filter: { type: Object, default: () => { return {} } },
            initialValue: { type: Array, default: () => { return [] } }
        },
        data() {
            let map = [];
            for (const f of this.initialValue) {
                map.push({ [this.idKey()]: f['value'], [this.labelKey()]: f['label'] })
            }
            return {
                selected: map
            }
        },
        computed: {
            // idKey() { return this.filter.idKey ? this.filter.idKey : 'id' },
            // labelKey() { return this.filter.labelKey ? this.filter.labelKey : 'name' },
            hasSearch() { return this.filter.hasSearch ? Boolean(this.filter.hasSearch) : false },
        },
        methods: {
            idKey() { return this.filter.idKey ? this.filter.idKey : 'id' },
            labelKey() { return this.filter.labelKey ? this.filter.labelKey : 'name' },
            reset() {
                this.$refs.list.reset();
            },
            resetValue(value) {
                this.$refs.list.remove(value);
            },
            onFilterAdded(name, value) {
                this.$emit('filter-added', name, value[this.idKey()], value[this.labelKey()], null, this.filter.link, this.filter.linkValue);
            },
            onFilterRemoved(name, value) {
                this.$emit('filter-removed', name, value[this.idKey()], value[this.labelKey()], null, this.filter.link, this.filter.linkValue);
            }
        }
    }
</script>

<style scoped>

</style>